export default "__VITE_ASSET__CKf_WhCH__"